import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { FormControl, IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { ICommonProperties } from '../../../common/properties/ICommonProperties';

export interface IFormTextFieldProperties extends ICommonProperties {
  label: string;
  onChange: (newValue: string) => void;
  value?: string;
  type?: string;
  errorMessage?: string | null;
  isHaveErrors?: boolean;
  multiline?: boolean;
  rows?: string | number | undefined;
  helperText?: string | false | null | undefined;
  required?: boolean | undefined;
  disabled?: boolean;
  style?: any;
  inputProps?: any;
  variant?: 'outlined' | 'filled' | 'standard';
  dataCy?: string;
  size?: any;
  paddingSizing?: number;
}

export const FormTextField = observer(
  ({
    label,
    onChange,
    value = '',
    multiline = false,
    type = 'text',
    errorMessage = null,
    rows = undefined,
    helperText = undefined,
    required = false,
    disabled = false,
    style = {},
    inputProps = {},
    variant = 'outlined',
    dataCy,
    size = 'normal',
    paddingSizing = 2,
    isHaveErrors = false,
    ...rest
  }: IFormTextFieldProperties & Omit<TextFieldProps, keyof IFormTextFieldProperties>) => {
    const [isHidden, setIsHidden] = useState(true);
    const onTextFieldChange = (event: any) => {
      onChange(event.target.value);
    };

    return (
      <FormControl fullWidth variant="outlined" sx={{ padding: paddingSizing }}>
        <TextField
          style={style}
          disabled={disabled}
          required={required}
          error={!!errorMessage || isHaveErrors}
          helperText={isHaveErrors || !!errorMessage ? errorMessage : helperText || null}
          value={value}
          onChange={onTextFieldChange}
          color="secondary"
          label={label}
          variant={variant}
          multiline={multiline}
          rows={rows}
          inputProps={inputProps}
          data-cy={dataCy}
          size={size}
          type={type === 'password' && value ? (!isHidden ? 'text' : 'password') : type}
          InputProps={{
            endAdornment: type === 'password' && value && (
              <InputAdornment position="end">
                <IconButton
                  aria-label={!isHidden ? 'hide the password' : 'display the password'}
                  onClick={() => setIsHidden(!isHidden)}
                  edge="end"
                >
                  {!isHidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          {...rest}
        />
      </FormControl>
    );
  },
);
